import { useState, useEffect } from 'react';
import { DataServiceHookResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useExecutePayrollMandateService } from '../../../../contexts/Payroll/hooks';
import { ExecuteMandateResponseBody } from '../../../../domain/Authorization/entities/ExecuteMandateResponseDTO';

const usePayrollExecuteService = (
  successCallback: () => void,
  requestId?: Nullable<string>,
): DataServiceHookResponse<ExecuteMandateResponseBody> => {
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);
  const executePayrollService = useExecutePayrollMandateService()();

  const shouldExecutePayroll = Boolean(requestId) && Boolean(timestamp);

  useEffect(() => {
    if (!timestamp) {
      setTimestamp(new Date().toISOString());
    }
  }, [timestamp]);

  // Initiate Authorization
  return useInvokeSWRService<ExecuteMandateResponseBody>(
    executePayrollService,
    {
      requestId,
      successCallback,
      meta: { timestamp },
    },
    shouldExecutePayroll,
    'authorizationService.ExecuteMandate',
  );
};

export { usePayrollExecuteService };
